export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const DELETE_COMPANY = "REMOVE_COMPANY";
export const ADD_COMPANY = "ADD_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const FETCH_COMPANY = "FETCH_COMPANY";



export const SET_COMPANY = "SET_COMPANY";




export const FETCH_USERS = "FETCH_USERS";
export const REMOVE_USER = "REMOVE_USER";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const FETCH_USER = "FETCH_USER";

export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER";


export const FETCH_OTHER_USER = "FETCH_OTHER_USER";
export const UPDATE_OTHER_USER = "UPDATE_OTHER_USER";


export const ADD_SERVER_ERROR = "ADD_SERVER_ERROR";
export const DELETE_SERVER_ERROR = "DELETE_SERVER_ERROR";
export const SET_GLOBAL_VAR = "SET_GLOBAL_VAR";

export const ADD_TEXTBAUSTEIN = "ADD_TEXTBAUSTEIN";
export const FETCH_TEXTBAUSTEINE = "FETCH_TEXTBAUSTEINE";
export const UPDATE_TEXTBAUSTEIN = "UPDATE_TEXTBAUSTEIN";
export const DELETE_TEXTBAUSTEIN = "DELETE_TEXTBAUSTEIN";

export const ADD_KLAUSUR = "ADD_KLAUSUR";
export const ADD_SCHUELER = "ADD_SCHUELER";
export const UPDATE_SCHUELER = "UPDATE_SCHUELER";
export const ADD_ALL_SCHUELER = "ADD_ALL_SCHUELER";

